import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSubscription } from '@/api/virtual-lab-svc/queries/subscription';
import { keyBuilder } from '@/ui/use-query-keys/user';
import type { CreateSubscriptionRequest } from '@/api/virtual-lab-svc/queries/types';
export function useCreateSubscriptionMutation() {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: keyBuilder.subscription()
        });
        queryClient.invalidateQueries({
          queryKey: keyBuilder.invoices()
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}
function _temp(payload) {
  return createSubscription(payload);
}